import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initAnalytics } from "@/lib/analytics";
import { initVitalsRUM } from "@/lib/vitals";

initAnalytics();
initVitalsRUM();

const mount = () => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
};

// Prerendered pages ship a static hero <img fetchpriority="high">. Mount only
// after it has painted (max 1.5s), so React never swaps it out mid-decode and
// the static image stays the page's LCP instead of React's copy.
const staticHero = document.querySelector('#root img[fetchpriority="high"]');
if (staticHero) {
  let started = false;
  let mounted = false;
  const mountOnce = () => {
    if (mounted) return;
    mounted = true;
    mount();
  };
  const go = () => {
    if (started) return;
    started = true;
    // Next frame = after the image paints; timer covers background tabs (no rAF).
    requestAnimationFrame(() => setTimeout(mountOnce, 0));
    setTimeout(mountOnce, 250);
  };
  if (staticHero.complete) go();
  staticHero.addEventListener("load", go, { once: true });
  staticHero.addEventListener("error", go, { once: true });
  setTimeout(go, 1500);
} else {
  mount();
}
